import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsParentSection} from "../../const";
import {SettingsSection, SettingsSectionTitleDict} from "../../@const";

export default class TodoListSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "Todo Lists",
            description              : "ToDo List Templates allow you to have certain items be in your ToDo List upon creation. To create a ToDo list from a template, click the \"Add\" icon and select \"ToDo list from template\" from the drop down.",
            svgIcon                  : "isvg-todo-list",
            settingsUrl              : "settings/todo-list",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION,
            typeLabel                : SettingsSectionTitleDict[SettingsSection.TASKS_PROJECTS]

        });

        this.parentSection          = SettingsParentSection.TASKS_PROJECTS
    }

}
